<brm-app [title]="title" [navItems]="navItems" [otherRoutes]="otherRoutes">
  <div content-header>
    <motion-breadcrumb symbol=" > " class="no-print"></motion-breadcrumb>
  </div>
</brm-app>
